import { render, staticRenderFns } from "./ChangeNotification.vue?vue&type=template&id=7b00f3de&"
import script from "./ChangeNotification.vue?vue&type=script&lang=js&"
export * from "./ChangeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports